export const API = {
  DEFAULT_HEADER: {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=UTF-8',
  },
  METHOD: {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
  },
  RESPONSE: {
    ACCEPTED: 202,
    SUCCESS: 200,
    FAILURE: 404,
    CREATED: 201,
    CONFLICT: 409,
    SERVER_ERROR: 500,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403
  },
};
